import "./styles.scss";
import * as React from "react";
const ResponsivePie = React.lazy(() => import("@nivo/pie").then(m => ({ default: m.ResponsivePie })));

interface PieChartProps {
  data: any;
  title: string;
}

const PieChart: React.FC<PieChartProps> = ({ data, title }) => {
  return (
    <div className="chart">
      <div className="chartTitle">{title}</div>
      <div className="chartSvg">
        <ResponsivePie
          data={data}
          margin={{ top: 50, right: 50, bottom: 50, left: 50 }}
          innerRadius={0.5}
          padAngle={0.6}
          cornerRadius={2}
          activeOuterRadiusOffset={8}
          arcLinkLabelsTextColor="#333333"
          arcLinkLabelsThickness={2}
          arcLinkLabelsDiagonalLength={8}
          arcLinkLabelsStraightLength={8}
          arcLinkLabelsTextOffset={4}
          arcLinkLabelsColor={{ from: "color" }}
          arcLabelsSkipAngle={20}
          arcLinkLabelsSkipAngle={20}
          arcLabelsTextColor={{ from: "color", modifiers: [["darker", 2]] }}
        />
      </div>
    </div>
  );
};
export default PieChart;
